import { SearchInput } from "PFApp/components/search_input";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./search_box.module.scss";

interface SearchBoxProps {
  value: string | null;
  onChange: (value: string | null) => void;
}

export const SearchBox = ({ value, onChange }: SearchBoxProps): JSX.Element => {
  const { t } = useTranslation("bookingModule", { keyPrefix: "reports.exportWizard.fields" });

  return (
    <SearchInput
      classes={{
        root: css.searchInputRoot,
        input: css.searchInput
      }}
      term={value || ""}
      onTermChange={onChange}
      qaId="WorkflowPageEngagementSearch"
      placeholder={t("searchField")}
      debounceTime={0}
      withSearchIcon
    />
  );
};
